import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface BlueprintFormProps {
  name: string;
  description: string;
  isPublic: boolean;
  isCollaborative: boolean;
  themeId: number;
  themes: Array<{id: number, name: string}>;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onPublicChange: (value: boolean) => void;
  onCollaborativeChange: (value: boolean) => void;
  onThemeChange: (value: number) => void;
}

export function BlueprintForm({
  name,
  description,
  isPublic,
  isCollaborative,
  themeId = 0,
  themes = [],
  onNameChange,
  onDescriptionChange,
  onPublicChange,
  onCollaborativeChange,
  onThemeChange,
}: BlueprintFormProps) {
  // Ensure themes is always an array
  const safeThemes = Array.isArray(themes) ? themes : [];

  return (
    <div className="space-y-4 w-full max-w-3xl mx-auto">
      <div className="space-y-2">
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Enter blueprint name"
          className="w-full"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Enter blueprint description"
          rows={3}
          className="w-full resize-none"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="theme">Theme</Label>
        <Select
          value={themeId ? themeId.toString() : ""}
          onValueChange={(value) => onThemeChange(Number(value))}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select theme" />
          </SelectTrigger>
          <SelectContent>
            {safeThemes.map((theme) => (
              <SelectItem key={theme.id} value={theme.id.toString()}>
                {theme.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
        <div className="flex items-center gap-2">
          <Switch
            id="visibility"
            checked={isPublic}
            onCheckedChange={onPublicChange}
          />
          <Label htmlFor="visibility" className="cursor-pointer">Public</Label>
        </div>

        <div className="flex items-center gap-2">
          <Switch
            id="collaborative"
            checked={isCollaborative}
            onCheckedChange={onCollaborativeChange}
          />
          <Label htmlFor="collaborative" className="cursor-pointer">Collaborative</Label>
        </div>
      </div>
    </div>
  );
} 